<template>
    <div class="layout-container table-special">
        <el-tabs type="border-card">
            <el-tab-pane label="问题审核">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con" :class="'show'">
                        <div class="search-condition">
                            <span class="label">问题名称</span>
                            <div class="input-condition">
                                <el-input v-model="condition.ask_name" placeholder="请输入问题关键词"></el-input>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label" >话题名称</span>
                            <div class="input-condition">
                                <el-input v-model="condition.topic_name" placeholder="请输入话题关键词"></el-input>
                            </div>
                        </div>
                       <div class="search-condition">
                            <span class="label">站点</span>
                            <div class="input-condition">
                                <site-auto-complete v-model="condition.site_id" @created="initData"  :clueId=1  :owned="true" :init-choose-first="false" :dataType=1 ref="siteAutoComplete"></site-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition" v-if="condition.site_id!=0">
                            <span class="label">楼盘名称</span>
                            <div class="input-condition">
                                <house-auto-complete v-model="condition.house_id" :site-id="condition.site_id" clearable></house-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition search-condition-time" style="min-width: 400px;">
                            <span class="label">提问时间</span>
                            <div class="input-condition">
                                <el-date-picker
                                        v-model="condition.time"
                                        type="datetimerange"
                                        range-separator="至"
                                        start-placeholder="请选择开始日期"
                                        end-placeholder="请选择结束日期"
                                        align="right"
                                        value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm"
                                        @change="pickerChangeFn"
                                >
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button  @click="resetSearch()">清空条件</el-button>
                        <Permission allowed="operating.house-topic.house-topic-ask.check"  isRow="1">
                            <el-button type="primary" class="inline" @click="batchConfirm()">批量审核</el-button>
                        </Permission>
                        <Permission allowed="operating.house-topic.house-topic-ask.delete"  isRow="1">
                            <el-button type="primary" class="inline"  @click="batchDelete()">批量删除</el-button>
                        </Permission>
                    </div>
                </div>
                <el-table
                    :data="list"
                    style="width: 100%"
                    :highlight-current-row="true"
                    stripe
                    tooltip-effect="dark"
                    ref="multipleTable"
                    v-loading="isLoading"
                    header-cell-class-name="table-back"
                    class="list-table"
                    @selection-change="selectItem"
            >
                <el-table-column type="selection" width="50" ></el-table-column>
                <el-table-column  label="问题名称" prop="ask_name"   align="center"></el-table-column>
                <el-table-column  label="话题名称" prop="topic_name"   align="center"></el-table-column>
                <el-table-column  label="楼盘名称" prop="house_name"   align="center"></el-table-column>
                <el-table-column  label="站点" prop="site_name"   align="center"></el-table-column>
                <el-table-column  label="问题状态" prop="status_name" align="center"></el-table-column>
                <el-table-column  label="提问人" prop="creator"  align="center"></el-table-column>
                <el-table-column  label="提问时间" prop="created_at"  width="180"  align="center"></el-table-column>
                <el-table-column label="操作"   width="300px" align="center">
                    <template slot-scope="scope">
                        <el-button v-permission="'operating.house-topic.house-topic-ask.check'"  size="mini" @click="confirmStatus(scope.row.id)"
                            >审核</el-button>
                        <el-button v-permission="'operating.house-topic.house-topic-ask.edit'"  size="mini" @click="openEdit(scope.row)"
                            >编辑</el-button>
                        <el-button v-permission="'operating.house-topic.house-topic-ask.delete'"  size="mini" @click="handleDelete(scope.row.id)"
                            >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
             <template v-if="list.length > 0">
                <el-pagination
                    background
                    layout="total,prev, pager, next"
                    :current-page="condition.page"
                    :total="condition.total"
                    :page-size="condition.per_page"
                    @current-change="currentChange"
                ></el-pagination>
            </template>

            </el-tab-pane>
        </el-tabs>
        <el-dialog
            title="审核提问"
            :visible.sync="confirmDialogVisible"
            width="30%"
            :before-close="handleConfirmClose">
            <p class="tips">请认真审核提问是否合规，审核通过后该问题会在前台页面展示。</p>
            <div class="popover-slider-bar ">
                <el-form class="form-container clearfix" :rules="rules" :model="confirmInfo" ref="confirmValidateForm">
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">审核结果</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item" prop="status">
                            <el-select v-model="confirmInfo.status" placeholder="请选择">
                                <el-option
                                    v-for="item in typeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="form-item" v-if="confirmInfo.status == 3">
                        <div class="form-label">
                            <span class="label">审核结果</span>
                        </div>
                        <div class="form-input-item">
                            <el-form-item prop="topic_desc">
                                <el-input type="textarea" v-model="confirmInfo.reject_reason" placeholder="请输入拒绝理由"></el-input>              
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-item" style="float:right;">
                        <span  slot="footer" class="dialog-footer">
                             <el-button @click="confirmDialogVisible = false">取 消</el-button>
                            <el-button type="primary" @click="submitConfirmForm('confirmValidateForm')">确 定</el-button>
                        </span>
                       
                    </div>
                </el-form>
            </div>
        </el-dialog>
         <el-dialog
            title="编辑提问"
            :visible.sync="editDialogVisible"
            width="30%"
            :before-close="handleEditClose">
             <div class="popover-slider-bar ">
                <el-form class="form-container clearfix"  ref="editValidateForm">
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">问题名称</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item prop="topic_desc">
                                <el-input type="textarea" maxlength="50" v-model="EditInfo.ask_name" placeholder="请输入问题名称（50个字符以内）"></el-input>              
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">所属话题</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-select v-model="EditInfo.topic_id" placeholder="请选择">
                                <el-option
                                    v-for="item in bankList"
                                    :key="item.id"
                                    :label="item.topic_name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </div>
                    </div>
                   
                    <div class="form-item" style="float:right;">
                        <span  slot="footer" class="dialog-footer">
                             <el-button @click="editDialogVisible = false">取 消</el-button>
                            <el-button type="primary" @click="submitEdit('editValidateForm')">确 定</el-button>
                        </span>
                       
                    </div>
                </el-form>
            </div>
        </el-dialog>

    </div>
</template>
<style>
    td a:link{
        color: #606266;
    }
    td a:visited{
        color: #606266;
    }
</style>
<script>
    import {getTopiclList,getAskList,deleteBatchAsk,conformBatchAsk,editAskContent,getAskDetail} from '@/service/topicBank'
    import SiteAutoComplete from "@/components/auto-complete/site-auto-complete";
    import HouseAutoComplete from "@/components/auto-complete/house-auto-complete";

    export default {
        name: "List",
        components: {
            HouseAutoComplete,
            SiteAutoComplete,
        },
        data () {
            return {
                pages:{
                    total:0,
                    size:1,
                },
                isLoading:false,
                condition: {
                    house_id: '',
                    site_id: '',
                    ask_name: '',
                    topic_name: '',
                    time:'',
                    per_page:10,
                    page:1,
                },
                rules:{
                    status: [
                        { required: true, message: '请选择审核状态', trigger: 'change' },
                    ],
                },
                editRules:{

                },
                confirmInfo:{
                    status:'',
                    reject_reason:''
                },
                confirmType:1, //1 批量审核 2 单个审核
                activeId:null,
                confirmDialogVisible:false,
                list:[],
                sels:[],
                typeList: [
                    {'name':'审核通过','id':2},
                    {'name':'审核拒绝','id':3},
                ],
                editDialogVisible:false,
                EditInfo:{},
                bankCon:{
                    per_page:1000,
                    page:1,
                    house_id:'',
                },
                bankList:[],
            }
        },
        mounted () {
            this.initData();
            //this.getBankList();
        },
         methods: {
            selectItem (val) {
                this.sels = val // 返回的是选中的列的数组集合
            },
            pickerChangeFn(){

            },
             handleSearch() {
                this.condition.page=1
                this.initData();
            },
            resetSearch() {
                this.condition = {
                    house_id: '',
                    site_id: '',
                    ask_name: '',
                    topic_name: '',
                    time:'',
                    per_page:10,
                    page:1,
                }
                this.initData();
            },

           openEdit(item){
                getAskDetail(item.id).then((data) => {
                    this.EditInfo = data;
                    this.EditInfo.topic_id=this.EditInfo.topic_id*1;
                    this.getBankList(data.house_id);
                })
                this.editDialogVisible = true;

           },
            currentChange(index) {
                this.condition.page = index;
                this.initData();
            },
            async getBankList(houseId) {
                this.bankCon.house_id = houseId
                await getTopiclList(this.bankCon).then((data) => {
                    this.bankList = data.data
                })
            },
            async initData() {
                this.isLoading = true;
                let query = this.condition;
                 if(this.condition.time && this.condition.time.length>1) {
                    query['created_at_start'] = this.condition.time[0]
                    query['created_at_end'] = this.condition.time[1]
                }
                this.list=[]
                await getAskList(this.condition).then((data) => {
                    this.condition.total=data.total
                    this.list = data.data
                })
                this.isLoading = false;
            },
            confirmStatus(id){
                this.confirmType = 2;
                this.activeId = id;
                this.confirmDialogVisible= true;
            },
            batchConfirm(){
                if (this.sels.length <= 0) {
                    this.$message({
                        type: 'error',
                        message: '请选择要批量审核的问题'
                    })
                return null
                }
                this.confirmType = 1;
                this.confirmDialogVisible= true;
            },
            handleDelete(id) {
                let query={};
                query.ids = id;
                this.$confirm("是否确认删除该问题，删除后不可恢复", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    deleteBatchAsk(query)
                    .then(() => {
                        this.$message({
                        type: "success",
                        message: "删除成功"
                        });
                        this.initData();
                    })
                    .catch(err => {
                        this.$message({
                        type: "error",
                        message: err.message || "删除失败"
                        });
                    });
                });
            },
            batchDelete(){
                if (this.sels.length <= 0) {
                    this.$message({
                        type: 'error',
                        message: '请选择要批量删除的问题'
                    })
                return null
                }
                let query = {};
                query.ids = this.sels.map(v => v.id).join('_');
                this.$confirm("是否确认删除该提问，删除后不可恢复", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    deleteBatchAsk(query)
                    .then(() => {
                        this.$message({
                        type: "success",
                        message: "删除成功"
                        });
                        this.initData();
                    })
                    .catch(err => {
                        this.$message({
                        type: "error",
                        message: err.message || "删除失败"
                        });
                    });
                });
            },
            submitConfirmForm(formName){
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        if(this.confirmInfo.status == ''){
                             this.$message({
                                type: 'error',
                                message: '请选择审核结果'
                            })
                            return null
                        }
                        let query = this.confirmInfo;
                        if(this.confirmType == 1){
                            query.ids = this.sels.map(v => v.id).join('_')
                        }else{
                            query.ids = this.activeId;
                        }
                        conformBatchAsk(query)
                        .then(() => {
                            this.$message({
                            type: "success",
                            message: "审核成功"
                            });
                            this.handleConfirmClose();
                            this.initData();
                        })
                        .catch(err => {
                            this.$message({
                            type: "error",
                            message: err.message || "审核失败"
                            });
                        });
                    } else {
                        return false
                    }
                })
            },
            handleConfirmClose(){
                this.confirmInfo = {
                     status:'',
                    reject_reason:''
                }
                this.$refs.confirmValidateForm && this.$refs.confirmValidateForm.clearValidate()
                this.confirmDialogVisible = false;
            },
            handleEditClose(){
                this.editDialogVisible = false;

            },
            submitEdit(){
                if (this.EditInfo.ask_name == '') {
                    this.$message({
                        type: 'error',
                        message: '问题名称不能为空'
                    })
                    return null
                }
                let topicInfo = this.bankList.filter( item => item.id == this.EditInfo.topic_id);
                this.EditInfo.topic_name = topicInfo[0].topic_name;
                editAskContent(this.EditInfo.id,this.EditInfo)
                .then(() => {
                    this.$message({
                    type: "success",
                    message: "编辑问题成功"
                    });
                    this.handleEditClose();
                    this.initData();
                })
                .catch(err => {
                    this.$message({
                    type: "error",
                    message: err.message || "编辑问题失败"
                    });
                });
            },
         }
    }
</script>

<style scoped>
.inline{
    margin-left:5px;
}
.tips{
    padding-left:20px;
}
.name{
    margin-bottom:10px;
}

</style>